import axiosInstance from 'helpers/axiosInstance';
import { TPagingParams } from 'modules/MyBills';
import { getBusinessId } from 'helpers/query';
import { IBillHistory } from 'modules/MyBills';
import { UserInfo } from 'stores/type';
import { DecryptParams } from 'modules/Cancellation/reducers/type';
import { downloadPdf } from 'helpers/tools';
import { CancellationForm } from 'modules/Cancellation/components/Form/Form';

export const getBillHistory = (pagingParams: TPagingParams = { page: 1, pageSize: 10 }) => {
    return axiosInstance.get<IBillHistory>('/api/invoices', {
        params: {
            ...pagingParams,
            businessId: getBusinessId(),
        },
    });
};

export const getUserInfo = () => {
    return axiosInstance.get<UserInfo>('/api/userInfo', {
        params: {
            businessId: getBusinessId(),
        },
    });
};

export const getDecryptedData = (params: DecryptParams) => {
    return axiosInstance.get<string>('/api/parse-id', {
        params,
    });
};

export type RequestCancellationData = CancellationForm & { uuid: string };

export const sendCancellationRequest = (data: RequestCancellationData) => {
    return axiosInstance.post('/api/request-cancellation', data);
};

export const downloadBill = async (invoiceNumber: string): Promise<void> => {
    return axiosInstance
        .get(`/api/invoices/${invoiceNumber}.pdf`, {
            responseType: 'blob',
        })
        .then(r => r.data)
        .then(r => downloadPdf(r, invoiceNumber));
};
